var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEquityavail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.547,
    height: 39.226,
    viewBox: "0 0 227.547 39.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.24 -22.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.01,24.79h4.922v1.05h-3.756v1.792h3.333v1.05h-3.333v2.673h-1.161V24.79Z",
    transform: "translate(-46.018 -0.949)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.784,24.69h1.079l2.909,6.612h-1.228l-.669-1.584h-3.126L114.07,31.3h-1.19Zm1.662,4L116.3,26.067l-1.132,2.625Z",
    transform: "translate(-52.172 -0.897)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36,24.79h2.947a2.682,2.682,0,0,1,1.907.655,1.967,1.967,0,0,1,.549,1.416v.019a1.974,1.974,0,0,1-1.575,1.989l1.787,2.485h-1.368l-1.623-2.288H132.53v2.288H131.37V24.79Zm2.861,3.251c.833,0,1.358-.433,1.358-1.1v-.019c0-.7-.51-1.088-1.368-1.088h-1.69v2.206h1.7Z",
    transform: "translate(-61.752 -0.949)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.24,45.47H23.307l6.559-11.255L23.307,22.96H12.24L18.8,34.215Z",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.447,47.61H52.379L45.82,58.865,52.379,70.12H63.447L56.892,58.865Z",
    transform: "translate(-17.408 -12.779)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.683 33.743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.37,47.34H118.3v5.225H106.486v3.41h10.7v4.874h-10.7v3.535h11.977v5.254H100.37V47.34Z",
    transform: "translate(-100.37 -46.382)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,72.375a11.957,11.957,0,0,1-.954,1.021,6.344,6.344,0,0,1-1.132.843,5.949,5.949,0,0,1-1.4.588,6.278,6.278,0,0,1-1.734.222,7.038,7.038,0,0,1-2.914-.621,7.362,7.362,0,0,1-2.437-1.767,8.5,8.5,0,0,1-1.671-2.8,10.542,10.542,0,0,1-.621-3.728v-.063a10.8,10.8,0,0,1,.621-3.776,8.9,8.9,0,0,1,1.657-2.837,7.11,7.11,0,0,1,5.336-2.4,6.119,6.119,0,0,1,3.183.746,8.307,8.307,0,0,1,2.071,1.734v-2.1h6.054V79.753h-6.054V72.375Zm-3.4-2.389a3.409,3.409,0,0,0,1.387-.289,3.333,3.333,0,0,0,1.132-.814,3.835,3.835,0,0,0,.746-1.243,4.466,4.466,0,0,0,.27-1.575V66a4.466,4.466,0,0,0-.27-1.575,3.921,3.921,0,0,0-.746-1.243,3.287,3.287,0,0,0-1.132-.814,3.376,3.376,0,0,0-1.387-.289,3.255,3.255,0,0,0-1.368.289,3.355,3.355,0,0,0-1.113.814A4.151,4.151,0,0,0,147.764,66v.063a4.151,4.151,0,0,0,1.055,2.817,3.355,3.355,0,0,0,1.113.814A3.256,3.256,0,0,0,151.3,69.986Z",
    transform: "translate(-121.868 -51.415)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,75.467a5.57,5.57,0,0,1-4.33-1.7,6.65,6.65,0,0,1-1.56-4.667V57.85h6.054v9.333a3.115,3.115,0,0,0,.669,2.167,2.306,2.306,0,0,0,1.782.732,2.456,2.456,0,0,0,1.83-.732,2.978,2.978,0,0,0,.718-2.167V57.85h6.054V75.082h-6.054V72.693a8.845,8.845,0,0,1-.925,1.035,6.5,6.5,0,0,1-1.146.877,6.38,6.38,0,0,1-1.4.621A5.689,5.689,0,0,1,193.5,75.467Z",
    transform: "translate(-145.595 -51.83)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,45.35h6.309v4.46H229.86Zm.13,6.02h6.054V68.6H229.99Z",
    transform: "translate(-167.497 -45.35)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.556,70.737a6.368,6.368,0,0,1-4.277-1.305q-1.524-1.308-1.522-4.4V58H247.72V53.153h2.037V48.79h6.054v4.363h4.012v4.84h-4.012v5.885a1.808,1.808,0,0,0,.414,1.329,1.728,1.728,0,0,0,1.243.4,4.235,4.235,0,0,0,1.18-.169A6.843,6.843,0,0,0,259.76,65v4.715a8.976,8.976,0,0,1-1.878.732A8.765,8.765,0,0,1,255.556,70.737Z",
    transform: "translate(-176.756 -47.133)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.624,57.845h6.213l-6.309,16.818a18.065,18.065,0,0,1-1.18,2.6,6.625,6.625,0,0,1-1.368,1.734,4.719,4.719,0,0,1-1.753.973,7.71,7.71,0,0,1-2.264.3,10.367,10.367,0,0,1-2.962-.4,11.7,11.7,0,0,1-2.548-1.1l1.849-4.238a7.165,7.165,0,0,0,1.435.684,3.87,3.87,0,0,0,1.209.241,1.944,1.944,0,0,0,.78-.144,1.745,1.745,0,0,0,.655-.559L275.63,57.84h6.309l3.439,10.383Z",
    transform: "translate(-191.225 -51.825)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.883,47.01h5.957l9.492,22.457h-6.627l-1.594-4.012h-8.63l-1.594,4.012H309.42ZM324.3,60.639l-2.485-6.309L319.3,60.639Z",
    transform: "translate(-208.741 -46.211)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.93,57.85H361.3l3.313,10.065,3.342-10.065H374.2l-6.877,17.362h-5.51Z",
    transform: "translate(-232.334 -51.83)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.035,75.192a7.129,7.129,0,0,1-2.292-.352,5.039,5.039,0,0,1-1.816-1.035,4.875,4.875,0,0,1-1.209-1.671,5.425,5.425,0,0,1-.448-2.264v-.063a5.294,5.294,0,0,1,.5-2.355,4.778,4.778,0,0,1,1.368-1.7,5.907,5.907,0,0,1,2.119-1.021,10.726,10.726,0,0,1,2.769-.332,13.194,13.194,0,0,1,2.307.193,9.68,9.68,0,0,1,1.83.477v-.289a2.636,2.636,0,0,0-.843-2.1,3.9,3.9,0,0,0-2.6-.732,11.231,11.231,0,0,0-2.485.255,17.179,17.179,0,0,0-2.292.7L396.7,58.659a19,19,0,0,1,3.106-.973,17.863,17.863,0,0,1,3.872-.366,12.581,12.581,0,0,1,3.935.539,6.674,6.674,0,0,1,2.63,1.56,5.41,5.41,0,0,1,1.416,2.307,10.425,10.425,0,0,1,.429,3.169V74.8H406.13V72.986a7.452,7.452,0,0,1-2.148,1.594A6.528,6.528,0,0,1,401.035,75.192ZM403.2,71.4a3.124,3.124,0,0,0,2.182-.766,2.652,2.652,0,0,0,.843-2.071v-.795a6.82,6.82,0,0,0-1.1-.318,6.276,6.276,0,0,0-1.291-.125,3.246,3.246,0,0,0-2.056.573,1.89,1.89,0,0,0-.718,1.56v.063a1.7,1.7,0,0,0,.607,1.387A2.356,2.356,0,0,0,403.2,71.4Z",
    transform: "translate(-253.246 -51.555)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.67,45.35h6.309v4.46H436.67Zm.13,6.02h6.054V68.6H436.8Z",
    transform: "translate(-274.708 -45.35)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.85,45.35H462.9V68.6H456.85Z",
    transform: "translate(-285.169 -45.35)",
    fill: "#003b5c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.08 31.258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.339,40.19a.06.06,0,0,1,.067.048c.14.414.279.824.419,1.238.067.193.13.385.2.578a.074.074,0,0,0,.024.034c.2-.631.4-1.262.612-1.9h.857v2.774h-.568V41.028s0,0-.01,0l-.014.029c-.135.385-.265.771-.4,1.161-.082.241-.169.477-.25.718a.048.048,0,0,1-.053.039h-.4a.061.061,0,0,1-.043-.034c-.135-.376-.265-.751-.395-1.127-.087-.246-.169-.491-.255-.732,0,0,0-.01-.01-.014h-.01v1.845c0,.067,0,.067-.067.067h-.5V40.195",
    transform: "translate(-475.809 -40.19)",
    fill: "#003b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.7,42.974V40.71h-.828V40.2h2.273v.51h-.828c0,.029,0,.053,0,.072V42.9c0,.072,0,.072-.072.072H473.7Z",
    transform: "translate(-472.87 -40.195)",
    fill: "#003b5c"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityavail);
export default __webpack_public_path__ + "static/media/equityavail.08987191af7e5d71e704717eacf937ea.svg";
export { ForwardRef as ReactComponent };